// src/services/chat.ts
//
// Chat-domain service. Covers the file-upload endpoint used by the chat
// composer (multipart upload) and the two user-lookup endpoints used when
// constructing a new chat group.

import { apiFetch } from "../Component/api/apiFetch";
import { API_URLS } from "../Component/api/url";
import { handleJson } from "./http";

export const uploadFile = (formData: FormData): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.UPLOAD_FILE, { method: "POST", body: formData })
  );

export const getUser = (userId: string | number): Promise<any> =>
  handleJson(apiFetch(API_URLS.GET_USER(userId), { method: "GET" }));

export const getUserInfo = (userId: string | number): Promise<any> =>
  handleJson(apiFetch(API_URLS.GET_USER_INFO(userId), { method: "GET" }));
